<script setup lang="ts">
const { t } = useEkI18n();

const roleManagerStore = useRoleManagerStore();
const settingsStore = useSettingsStore();

const activeTabs = computed(() => {
  const activeTabs = [
    StartTabSetting.mine, 
    StartTabSetting.shared, 
    StartTabSetting.responsibleFor, 
    StartTabSetting.done,
    StartTabSetting.all
  ];
  const settings = settingsStore.settings;

  if (settings.worksheetsShowAllTab === false || roleManagerStore.hasShowAllTab === false) {
    activeTabs.splice(activeTabs.indexOf(StartTabSetting.all), 1);
  }

  if (settings.worksheetsShowResponsibleTab === false || roleManagerStore.hasShowResponsibleTab === false) {
    activeTabs.splice(activeTabs.indexOf(StartTabSetting.responsibleFor), 1);
  }

  return activeTabs;
});

async function updateStartTab(selected: StartTabSetting) {
  await settingsStore.set('worksheetsStartTab', selected);
}

</script>

<template>
  <SettingsSelect
    :options="activeTabs"
    :label="t('settings.worksheets.standardTab')"
    :description="t('settings.worksheets.standardTabDescription')"
    :value="settingsStore.settings.worksheetsStartTab"
    :placeholder="settingsStore.settings.worksheetsStartTab"
    :resolve-key="(o: StartTabSetting)=>o"
    @change="updateStartTab"
  >
    <template #option="{option}">
      {{ t("worksheetClassification." + option) }}
    </template>
  </SettingsSelect>
</template>

<style scoped>
.input-container{
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
</style>
